import React, { Component } from "react";
import { Accordion, Card, Button } from "react-bootstrap";
import "../css/infobox.css";
class InfoBox extends Component {
  constructor() {
    super();

    this.state = {
      guideState: "Expand Guide",
    };

    this.guideOnClick = this.guideOnClick.bind(this);
  }

  guideOnClick() {
    if (this.state.guideState == "Expand Guide")
      this.setState({ guideState: "Collapse Guide" });
    else this.setState({ guideState: "Expand Guide" });
  }

  render() {
    return (
      <div className="container mb-2">
        <div className="row">
          <Accordion className="accordion mt-2 mb-4" style={{ width: "100%" }}>
            <div className="internship-guide-container lfont">
              <div
                className="internship-header lfont col-12"
                id="headingOne"
                style={{ background: "0 0", border: "none", color: "#fff" }}
              >
                <div
                  className="title-container"
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "10px",
                    boxShadow: "0 2px 42px 0 rgb(0 0 0 / 20%)",
                    padding: "15px 30px",
                    marginTop: "35px",
                  }}
                >
                  {/* <div className="text-content mr-0 mr-md-5"> */}
                  <div
                    style={{
                      color: "#475058",
                      fontWeight: "700",
                      fontSize: "2rem",
                    }}
                  >
                    <h1 className="lfont to-center-xs post-title internship-page-title mt-2">
                      Internships are the surest path to a full-time job.
                    </h1>
                  </div>
                  <div className="mb-2">
                    <h6
                      style={{
                        color: "#828282",
                        marginTop: "5px",
                        lineHeight: "25px",
                        marginBottom: "12px",
                        display: "inline-block",
                        fontSize: "1.33rem",
                        // width: "38%",
                        // float: "left",
                      }}
                    >
                      Here's what you need to know.&nbsp;&nbsp;
                    </h6>

                    <Accordion.Toggle
                      as={Button}
                      onClick={this.guideOnClick}
                      variant="link"
                      eventKey="0"
                      style={{ display: "inline !important" }}
                    >
                      {this.state.guideState}
                    </Accordion.Toggle>
                    {/* </div> */}

                    {/* <Card.Link href="#">Card Link</Card.Link> */}
                  </div>
                </div>
                <Accordion.Collapse eventKey="0">
                  <Card.Body
                    style={{
                      // width: "80%",
                      WebkitBoxFlex: "0",
                      msFlex: "0 0 100%",
                      flex: "0 0 100%",
                      maxWidth: "100%",
                      marginLeft: "auto",
                      marginRight: "auto",
                      color: "#42464a",
                      // backgroundColor: "#fff",
                      // borderRadius: "10px",
                      // boxShadow: "0 2px 42px 0 rgb(0 0 0 / 20%)",
                      padding: "15px",
                      marginTop: "35px",
                    }}
                  >
                    <Card.Title
                    //   style={{
                    //     color: "#475058",
                    //     fontWeight: "700 !important",
                    //     fontSize: "2rem",
                    //     fontFamily: "Nunito,serif",
                    //   }}
                    >
                      By Status.fyi team
                    </Card.Title>
                    <Card.Subtitle className="mb-2 text-muted">
                      April 19, 2021
                    </Card.Subtitle>
                    <div className="socialmedia">
                      <ul>
                        <li>
                          <a href="#facebook">Facebook</a>
                        </li>
                        <li>
                          <a href="#twitter">Twitter</a>
                        </li>
                        <li>
                          <a href="#linkedin">Linkedin</a>
                        </li>
                      </ul>
                    </div>
                    {/* <Card.Text> */}
                    <Card.Body className="collapsed">
                      <p>
                        The next few semesters of college are going to be
                        different. Like many other students, you can use this
                        opportunity to find a great internship for Fall and
                        Winter to get paid instead of going to school. We're
                        here to help you find great programs to have a
                        successful Fall, Winter, and Summer.
                      </p>
                      <p>
                        A successful internship can result in a return
                        internship or full-time offer for upcoming graduates. At
                        some companies, conversion rates exceed 70%. We've
                        summarized the key insights you'll need to secure an
                        internship and get a full-time offer below.
                      </p>

                      <h2>Timing</h2>
                      <p>
                        Begin applying to Summer internships by July of the
                        previous year. At the latest, apply to your top choices
                        by October. Many will have filled up their intern quota
                        by December. You can always apply to open opportunities
                        and startups later in the new year. Typically these are
                        last minute positions or startups without formal
                        programs.
                      </p>
                      <p>
                        For smaller companies without a formal program, try cold
                        emailing an employee or recruiter with your resume and
                        why you're passionate about the company. Even if nothing
                        comes of it, the conversation may come in handy when
                        looking for full-time opportunities. If you need help
                        finding emails, ping us through the chat below and we'll
                        try to help you out as best we can. Check out this
                        Facebook group for some leads and tips.
                      </p>

                      <h2>Prepare</h2>
                      <p>
                        Internship interviews are typically heavily focused on
                        raw skills. For software internships, this means coding
                        ability. Practice solving coding problems. Try using
                        Leetcode, InterviewBit, HackerRank, Cracking the Coding
                        Interview, etc. Side projects demonstrate raw skills and
                        are a great way to make your resume stand out.
                      </p>
                      <p>
                        Although you may not always have a choice, communicate
                        the components or systems you're most passionate about.
                        Internship assignments can vary significantly across
                        teams / companies and managers are often willing to give
                        interns experimental, interesting projects. Although we
                        list salaries, internships are for learning and
                        generally salary should not be the deciding factor.
                      </p>

                      <h2>Succeed</h2>
                      <p>
                        Your mentor will have the most frequent contact with
                        you. Managers typically rely on mentors to decide
                        whether a return offer will be given. Chat regularly
                        with your mentor and provide substantial project updates
                        frequently (ex. once a day). Participate in team
                        discussions and take interest in other projects your
                        team is working on. Make it easy for your manager /
                        mentor to vouch for you by delivering projects ahead of
                        schedule and going above and beyond. At the end of your
                        internship, you may be asked to present your project to
                        the team. Ensure you're preparing for this presentation
                        by gathering presentable material throughout your
                        internship.
                      </p>
                    </Card.Body>
                    {/* </Card.Text> */}
                  </Card.Body>
                </Accordion.Collapse>
              </div>
            </div>
          </Accordion>
        </div>
      </div>
    );
  }
}

export default InfoBox;
